import React, { useState } from 'react';
import axios from 'axios';
import AlertComponent from '../components/AlertComponent';

// import '../styles/Alert.css';

const ChatGPTEVALANSComponent = ({ param1, param2 }) => {
    const [selectedAction, setSelectedAction] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const [wordLimit, setWordLimit] = useState(250);
    const [outputFormat, setOutputFormat] = useState('Plain Unformatted Text');

    const [showAlert, setShowAlert] = useState(false);
    const [createPromptClicked, setCreatePromptClicked] = useState(false);
    const [getAISupportClicked, setGetAISupportClicked] = useState(false);
    const [viewAISupportClicked, setViewAISupportClicked] = useState(false);
    const [aiResponse, setAIResponse] = useState(""); 
    const [loading, setLoading] = useState(false); 
    const apiKey = 'sk-OgERx93017n-Cozr2hiyQOXDb-Yy2ACGb9cAdpOXpET3BlbkFJ3iYMG6o2LHsi9ScAzfbOUHbm8Beo5acJiDgowHXZcA';

    const languageOptions = [
        { code: 'en', name: 'English' },
        { code: 'hi', name: 'Hindi' },
        { code: 'ar', name: 'Arabic' },
        { code: 'bn', name: 'Bengali' },
        { code: 'zh', name: 'Chinese' },
        { code: 'fr', name: 'French' },
        { code: 'de', name: 'German' },
        { code: 'gu', name: 'Gujarati' },
        { code: 'ja', name: 'Japanese' },
        { code: 'jv', name: 'Javanese' },
        { code: 'kn', name: 'Kannada' },
        { code: 'kok', name: 'Konkani' },
        { code: 'ko', name: 'Korean' },
        { code: 'ms', name: 'Malay' },
        { code: 'zh-CN', name: 'Mandarin' },
        { code: 'mr', name: 'Marathi' },
        { code: 'ne', name: 'Nepali' },
        { code: 'or', name: 'Oriya' },
        { code: 'ps', name: 'Pashto' },
        { code: 'pt-PT', name: 'Portuguese' },
        { code: 'pa', name: 'Punjabi' },
        { code: 'ru', name: 'Russian' },
        { code: 'sa', name: 'Sanskrit' },
        { code: 'si', name: 'Sinhala' },
        { code: 'ur', name: 'Urdu' },
        { code: 'vi', name: 'Vietnamese' },
    ];
    

    const handleLanguageChange = (e) => {
        const selectedCode = e.target.value;
        const selectedLangObj = languageOptions.find(lang => lang.code === selectedCode);
        if (selectedLangObj) {
        setSelectedLanguage(selectedLangObj.name);
        }
    };

    // const handleAISupportClicked = () => {
    //     alert("AI Support Is Available For Premium Version!");
    //     getAISupportClicked(true);
    //     setShowAlert(true);
    // };

    const handleCreatePromptClick = () => {
        setCreatePromptClicked(true);
    };

    const trimmedParam2 = param2.trim();
    // const fullText = `${selectedAction} ${param1} "${trimmedParam2}" in max ${wordLimit} characters in ${selectedLanguage} in output format ${outputFormat}`;
    const fullText = `${param1} ${trimmedParam2} in max ${wordLimit} characters in ${selectedLanguage} in output format ${outputFormat}`;

    const textLength = fullText.length;
    const totalLength = Number(textLength) + Number(wordLimit);
    // console.log("textLength: ",textLength);
    // console.log("wordLimit: ",wordLimit);
    // console.log("totalLength: ",totalLength);

    const numberOfUnits = Math.ceil(totalLength / 100);
    // console.log("numberOfUnits: ",numberOfUnits);

    const chargePer100Tokens = 0.00075;
    const usdToInr = 80.00;
    const facilityChargeMultiplyer = 3;
    const chatGPTCharge = numberOfUnits * chargePer100Tokens * usdToInr * facilityChargeMultiplyer;
    
    const handleViewAIPriceListClicked = () => {
        setViewAISupportClicked(true);
    };

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const handleAISupportClicked = async () => {
        setViewAISupportClicked(true);
        setLoading(true);
      
        try {
        //   console.log("Inside handleAISupportClicked!! ");
          const response = await axios.post(
            'https://api.openai.com/v1/completions',
            {
                model: 'text-davinci-003',
                prompt: fullText,
                max_tokens: wordLimit,
                temperature: 0.7,
            },
            {
              headers: {
                'Authorization': `Bearer ${apiKey}`, 
                'Content-Type': 'application/json',
              },
            }
          );
      
        //   console.log("Calling ChatGPT: ", response);

          setAIResponse(response.data.choices[0].text); 
        } catch (error) {
          console.error('Error fetching response from AI:', error);
          setAIResponse('Failed to get a response from AI for [ '+fullText+' ]');
        } finally {
          setLoading(false);
        }
      };

    // const handleAISupportClicked = async () => {
    //     setViewAISupportClicked(true);
    //     setLoading(true);
    
    //     try {
    //         console.log("Inside handleAISupportClicked!! ");

    //         const response = await fetch('https://api.openai.com/v1/completions', {
    //             method: 'POST',
    //             headers: {
    //                 'Authorization': `Bearer ${apiKey}`, 
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify({
    //                 model: 'text-davinci-003',
    //                 prompt: fullText,
    //                 max_tokens: wordLimit,
    //                 temperature: 0.7,
    //             }),
    //         });

    //         console.log("Calling ChatGPT for response: ", response);
            
    
    //         if (!response.ok) {
    //             throw new Error(`HTTP error! status: ${response.status}`);
    //         }
    
    //         const data = await response.json();
    //         console.log("Getting ChatGPT: ", data);
    
    //         setAIResponse(data.choices[0].text); 
    //     } catch (error) {
    //         console.error('Error fetching response from AI:', error);
    //         setAIResponse('Failed to get a response from AI for [ '+fullText+' ]');
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    return (
        <div className='text-white bg-gray-700 text-sm px-4 py-2'>
            <div className='ml-2 mr-2 flex justify-center mb-2 mt-4'>
                <h2 className='text-lg text-yellow-200'>Think5Whys AI Support For {param1}</h2>
            </div>
            <div className='ml-2 mr-2 flex flex-col justify-center text-black '>
                {/* <select onChange={(e) => setSelectedAction(e.target.value)} style={{ padding: '5px', marginRight: '5px', border: '1px solid #ccc', height: '34px', lineHeight: '24px' }}>
                    <option value="">Select Intent</option>
                    <option value="Evaluate for Short Answers Type Question and Give Marks out of 10: ">Evaluate for Short Answers Type Question and Give Marks out of 10</option>
                    <option value="Evaluate for Long Answers Type Question and Give Marks out of 10: ">Evaluate for Long Answers Type Question and Give Marks out of 10</option>
                </select> */}
                <select 
                    onChange={handleLanguageChange} 
                    style={{ padding: '5px', marginRight: '5px', border: '1px solid #ccc' }}
                >
                    <option value="English">Select Output Language</option>
                    {languageOptions.map((lang) => (
                    <option key={lang.code} value={lang.code}>
                        {lang.name}
                    </option>
                    ))}
                </select>
                <label className='text-white'>Output Characters Limit:</label>
                <input
                    type="number"
                    value={wordLimit}
                    placeholder="Max Char Limit"
                    className="text-black appearance-none mb-4"
                    min={250}
                    max={2500}
                    step={50}
                    style={{
                        width: '100px',
                        height: '34px',
                        lineHeight: '24px',
                        border: '1px solid #ccc',
                        color: 'black',
                        WebkitAppearance: 'none',
                        MozAppearance: 'textfield',
                        padding: '0 10px'
                    }}
                    onChange={(e) => setWordLimit(e.target.value)}
                />
                <select onChange={(e) => setOutputFormat(e.target.value)} style={{ padding: '5px', marginRight: '5px', border: '1px solid #ccc', height: '34px', lineHeight: '24px' }}>
                    <option value="Plain Unformatted Text">Plain Unformatted Text</option>
                    <option value="Plain Paragraphed Text">Plain Paragraphed Text</option>
                    <option value="HTML Div Only">HTML Div Only</option>
                </select>
            </div>

            <div className='ml-2 mr-2 flex justify-center text-white'>
                <button className='bg-blue-600 w-auto mt-2' onClick={handleCreatePromptClick}>
                    <span role="img" aria-label="AI Icon">🌟</span> Create Prompt
                </button>
            </div>
            <div className='flex flex-row justify-center text-yellow-200 mb-2'>
                <p>
                    Copy + paste the following prompt in ChatGPT or any other GenAI tool to 
                    create a statement for you and put into {param1} input box: </p>
            </div>
            {createPromptClicked && (
                <>
                <div className='flex flex-row justify-center text-white border-4 border-green-500 py-4 px-4'>
                    {textLength <= wordLimit ? (
                        <p className='border-red-500'>{fullText}.</p>
                    ) : (
                        <p className='border-red-500'>Text exceeds the limit of {wordLimit} characters.</p>
                    )}
                </div>
                </>
            )}
            <div className='flex flex-col justify-center text-white mb-2 mt-4'>
                <p className='mb-4'>
                    Instead you want auto response from ChatGPT then you will incur a charge of 
                    <span className='text-yellow-200'> ₹ {chatGPTCharge.toFixed(2)}{' '}</span>
                    <span className='text-yellow-200'> for {totalLength}</span> request ({textLength}) and response ({wordLimit}) characters
                </p>
                <p className='mb-4'>
                    If you wish to take help from ChatGPT, your Think5Whys Wallet Will Be Charged. 
                    You must have at least <span className='text-yellow-200'>₹ {chatGPTCharge.toFixed(2)} </span> in your Think5Whys Wallet
                </p>
                {/* <p className='mb-4'>
                    Note - ChatGPT is an AI language model developed by OpenAI, 
                    designed to understand and generate human-like text based on the input it receives. 
                    It's powered by the GPT (Generative Pre-trained Transformer) architecture, 
                    specifically the GPT-4 version in its latest iteration. 
                    ChatGPT can be used for a variety of tasks.
                </p> */}
                <p className='mb-4'>
                    Disclaimer - Think5Whys is not responsible for any communication ie request and response 
                    happens between you and ChatGPT. Charges once occured will be irreversible.
                </p>                                
            </div>
            <div className='flex justify-center'>
                <button className='bg-lime-600 w-auto' onClick={handleAISupportClicked}>
                    <span role="img" aria-label="AI Icon">🤖</span> Get Help From AI
                </button>
            </div>
            {viewAISupportClicked && (
                <>
                <div className='flex flex-row justify-center text-white border border-green-500 py-2 mb-4'>
                    <p className='border-red-500 text-red-400'>{aiResponse}</p>
                </div>
                </>
            )}
            <div className='flex flex-wrap justify-between px-4 py-2'>
                <button className='bg-orange-600 text-white px-4 py-2 m-1 flex-shrink-0' onClick={handleAISupportClicked} disabled={true}>
                    What is prompt?
                </button>
                <button className='bg-orange-600 text-white px-4 py-2 m-1 flex-shrink-0' onClick={handleAISupportClicked} disabled={true}>
                    What is token and words?
                </button>
                <button className='bg-orange-600 text-white px-4 py-2 m-1 flex-shrink-0' onClick={handleAISupportClicked} disabled={true}>
                    What is execution?
                </button>
                <button className='bg-orange-600 text-white px-4 py-2 m-1 flex-shrink-0' onClick={handleAISupportClicked} disabled={true}>
                    What is temperature?
                </button>
            </div>
        </div>
    );
};

export default ChatGPTEVALANSComponent;
